(() => {
  if (window.__hbLoaded) return;
  window.__hbLoaded = true;

  // Icone du panier : 'toilet' (WC vu de cote) ou 'bag' (sac avec anneau d'abattant)
  const CART_ICON = 'toilet';

  const PATHS = {
    search: ['M10.5 4a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13z', 'M15.4 15.4 20 20'],
    account: ['M12 4.2a3.7 3.7 0 1 0 0 7.4 3.7 3.7 0 0 0 0-7.4z', 'M4.6 20c.5-3.8 3.7-6.1 7.4-6.1s6.9 2.3 7.4 6.1'],
    toilet: ['M14.6 3h4.1a.9.9 0 0 1 .9.9v6.6h-6V3.9a.9.9 0 0 1 .9-.9z', 'M4 10.9h15.6', 'M5.3 10.9c0 4 2.2 6.3 5.2 6.9V21h5.8'],
    bag: ['M5.2 8.4h13.6l.9 11.3a1.6 1.6 0 0 1-1.6 1.7H5.9a1.6 1.6 0 0 1-1.6-1.7z', 'M9 8.4V7a3 3 0 0 1 6 0v1.4', 'M12 11.6c-2.3 0-4 1.5-4 3.4 0 2 1.7 3.5 4 3.5s4-1.5 4-3.5c0-1.9-1.7-3.4-4-3.4z'],
  };

  function pathsMarkup(key) {
    return PATHS[key]
      .map((d) => `<path d='${d}' fill='none' stroke='currentColor' stroke-width='1.7' stroke-linecap='round' stroke-linejoin='round'></path>`)
      .join('');
  }

  function paintIcon(icon, key) {
    const svg = icon && icon.querySelector('svg');
    if (!svg) return;
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.removeAttribute('width');
    svg.removeAttribute('height');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    svg.innerHTML = pathsMarkup(key);
  }

  function setText(selector, text) {
    document.querySelectorAll(selector).forEach((el) => {
      if (el.textContent.trim() !== text) el.textContent = text;
    });
  }

  // Remplace le compteur (2) par une pastille 2 et masque la pastille quand le panier est vide
  function normalizeBubble(bubble) {
    const span = bubble.querySelector('span');
    const raw = span ? span.textContent : '';
    const digits = raw.split('').filter((c) => c >= '0' && c <= '9').join('');
    const count = digits ? parseInt(digits, 10) : 0;
    if (span && (raw.indexOf('(') !== -1 || raw.indexOf(')') !== -1)) span.textContent = String(count);
    bubble.setAttribute('data-count', String(count));
  }

  function watchBubble(bubble) {
    normalizeBubble(bubble);
    if (bubble.__hbWatched) return;
    bubble.__hbWatched = true;
    new MutationObserver(() => normalizeBubble(bubble)).observe(bubble, { childList: true, subtree: true, characterData: true });
  }

  // Grande barre de recherche au centre du header (ordinateur) : envoie vers la page de recherche
  function addSearchForm(body) {
    if (body.querySelector('.hb-search-form')) return;
    const right = body.querySelector(`[class^='header-right-']`);
    if (!right) return;
    const oldLink = right.querySelector(`a[class^='header-search-']`);
    const action = (oldLink && oldLink.getAttribute('href')) || '/search';
    const form = document.createElement('form');
    form.className = 'hb-search-form';
    form.setAttribute('action', action);
    form.setAttribute('method', 'get');
    form.setAttribute('role', 'search');
    form.innerHTML =
      `<input type='search' name='q' placeholder='Que recherchez-vous ?' autocomplete='off' aria-label='Rechercher sur le site'>` +
      `<input type='hidden' name='options[prefix]' value='last'>` +
      `<button type='submit' aria-label='Rechercher'><svg viewBox='0 0 24 24' aria-hidden='true' focusable='false'>${pathsMarkup('search')}</svg></button>`;
    body.insertBefore(form, right);
  }

  function init() {
    const body = document.querySelector(`[class^='header-body-']`);
    if (!body) return;

    const root = body.closest(`[class*=' header-']`);
    if (root) {
      root.classList.add('hb-header');
      if (root.firstElementChild) root.firstElementChild.classList.add('hb-settings');
    }
    body.classList.add('hb-body');

    const rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (window.location.pathname === rootPath || window.location.pathname === '/') {
      document.documentElement.classList.add('hb-home');
    }

    const logoCell = body.querySelector(`[class^='header-logo-']`);
    if (logoCell) logoCell.classList.add('hb-logo');
    const rightCell = body.querySelector(`[class^='header-right-']`);
    if (rightCell) rightCell.classList.add('hb-right');

    const items = [
      { link: `a[class^='header-search-']`, icon: `[class^='header-search-icon-']`, label: null, key: 'search', cls: 'hb-search', text: 'Rechercher' },
      { link: `a[class^='header-account-']`, icon: `[class^='header-account-icon-']`, label: `[class^='header-account-text-']`, key: 'account', cls: 'hb-account', text: 'Mon compte' },
      { link: `a[class^='header-cart-']`, icon: `[class^='header-cart-icon-']`, label: `[class^='header-cart-text-']`, key: CART_ICON, cls: 'hb-cart', text: 'Panier' },
    ];
    items.forEach((item) => {
      const link = body.querySelector(item.link);
      if (!link) return;
      link.classList.add('hb-btn', item.cls);
      link.setAttribute('aria-label', item.text);
      const icon = link.querySelector(item.icon);
      if (icon) icon.classList.add('hb-icon');
      paintIcon(icon, item.key);
      if (item.label) {
        const label = link.querySelector(item.label);
        if (label) label.classList.add('hb-label');
      }
    });

    const bubble = body.querySelector('.cart-count-bubble');
    if (bubble) watchBubble(bubble);

    const nav = document.querySelector(`ul[class*='header-menu-list-desktop-']`);
    if (nav) nav.classList.add('hb-nav');

    addSearchForm(body);
    document.querySelectorAll('.hb-chip').forEach((chip) => chip.remove());

    const logo = body.querySelector(`[class^='header-logo-image-'] img`);
    if (logo) logo.setAttribute('alt', 'Abattantswc');

    setText(`[class^='header-search-text-']`, 'Rechercher');
    setText(`[class^='header-account-text-']`, 'Mon compte');
    setText(`[class^='header-cart-text-']`, 'Panier');
    setText(`[class^='header-menu-mobile-'] a[href*='/search']`, 'Rechercher');
    setText(`[class^='header-menu-mobile-'] a[href*='/account']`, 'Mon compte');

    document.documentElement.classList.add('hb-ready');
  }

  init();
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
